module.exports = __webpack_public_path__ + "img/skilltest.e65da29a.svg";